import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import TabContainer from '../../../../../common/components/tab/containers/tab.containers';
import ManagementGatewayCockpitInsightsHome from './insights';

export const ManagementGatewayCockpits = () => {
    const [selectedTabIndex, setSelectedTabIndex] = React.useState<number | null>(null);
    const [searchParams, setSearchParams] = useSearchParams();

    const tabItems = [
        {
            id: 1,
            title: 'Private Network',
            component: <></>,
            isVisible: true,
        },
        {
            id: 2,
            title: 'Partner Network',
            component: <></>,
            isVisible: true,
        },
        {
            id: 3,
            title: 'Open Network',
            component: <></>,
            isVisible: true,
        },
        {
            id: 4,
            title: 'Insights',
            component: <ManagementGatewayCockpitInsightsHome />,
            isVisible: true,
        },
        {
            id: 5,
            title: 'Rejections',
            component: <></>,
            isVisible: true,
        },
    ];

    useEffect(() => {
        const tabTitleFromURL = searchParams.get('tab');
        if (tabTitleFromURL) {
            const tabIndex = tabItems.findIndex(tab => tab.title === tabTitleFromURL);
            if (tabIndex !== -1) {
                setSelectedTabIndex(tabIndex);
            }
        } else {
            setSelectedTabIndex(0);
        }
    }, [searchParams]);

    const handleTabChange = (index: number) => {
        setSelectedTabIndex(index);
        setSearchParams({ tab: tabItems[index].title });
    };

    if (selectedTabIndex === null) {
        return null;
    }

    return (
            <div className="flex flex-col items-center w-full px-5 h-[620px] overflow-auto">

        <TabContainer
            tabItems={tabItems}
            selectedIndex={selectedTabIndex}
            onChange={handleTabChange}
        />
        </div>
    );
};

export default ManagementGatewayCockpits;
